import React from "react";
import styled from "styled-components";

const Wrapper = styled.span`
  display: inline-block;
  font-family: Open Sans;
  font-weight: 700;
  font-size: 12px;
  text-transform: none;
  margin: 0 0 2.5rem;
  padding: 0.4rem 1rem 0.5rem;
  background:#A0A0A0;
  color: ${({ theme }) => theme.textColor.default};
  border-radius: ${({ theme }) => theme.borderRadius.default};
`;

const Tag = ({ children, color }) => {
  return (
    <Wrapper style={{ background: color }}>{children}</Wrapper>
  );
};
export default Tag;
